import React, { Component } from 'react';
import SmallScoreBarSection from './../../../../SmallScoreBarSection/SmallScoreBarSection';
import ScoreRange from './../../../../../constants/ScoreRange';
import ScoreBarTypes from '../../../../../constants/ScoreBarTypes';
import style from './style/abilitytochangecalculated.scss';

export default class AbilityToChangeCalculatedAttachment extends Component {
    abilityToChangeCalculatedAttachmentContent() {
        const { content } = this.props;
        const listOfScores = [];

        content.scores.map((score, index) => (listOfScores.push(
            <li key={ index } className={ style.abilityToChangeCalculated__score }>
                <SmallScoreBarSection
                    title={ score.name }
                    scoreMin={ ScoreRange.ABILITY_TO_CHANGE.MIN }
                    scoreMax={ ScoreRange.ABILITY_TO_CHANGE.MAX }
                    scoreValue={ score.score }
                    scoreLevelDescription={ score.evaluation }
                    iconType={ 'desktop' }
                    classes={{
                        root: style.scoreBlockSection__smallScoreBarSection,
                        fill: style.fill,
                        blank: style.blank,
                        scoreRoundIcon: style.groupedScoreBlockSection__scoreRoundIcon
                    }}
                    autoScaleWidth={ false }
                    scoreBarType={ ScoreBarTypes.NORMAL }
                >
                    <p className={ style.abilityToChangeCalculated__smallScoreBarSectionDescription }>
                        { score.definition }
                    </p>
                </SmallScoreBarSection>
            </li>
        )));

        return <div className={ style.abilityToChangeCalculated__contentWrapper }>
            { content.definition
                ? <p className={ style.abilityToChangeCalculated__definition } dangerouslySetInnerHTML={{ __html: content.definition }}/>
                : null }
            <ul className={ style.abilityToChangeCalculated__scoresWrapper }>
                { listOfScores }
            </ul>
        </div>;
    }

    render() {
        return <div>
            { this.abilityToChangeCalculatedAttachmentContent() }
        </div>;
    }
}
